/* ==========================================================================
   Follie by Alice - video sulla card prodotto
   Creato il 2026-09-22. Caricato da layout/theme.liquid.

   Desktop : forza il play del video al passaggio del mouse (risolve i casi
             in cui l'autoplay del browser non parte) e lo ferma all'uscita.
   Mobile  : primo tap sulla card = parte il video, secondo tap = pagina
             prodotto. Replica il comportamento aggiunto su Ella 6.
   ========================================================================== */
(function () {
  'use strict';

  var CARD_MEDIA = '.card__media';
  var CARD_LINK = '.card__media a.full-unstyled-link';
  var ACTIVE_CLASS = 'follie-video-on';

  var isCoarse = window.matchMedia && window.matchMedia('(hover: none)').matches;

  function getVideo(cardMedia) {
    if (!cardMedia) return null;
    return cardMedia.querySelector('deferred-media video, .deferred-media video');
  }

  function playVideo(video) {
    if (!video) return;
    try {
      video.muted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;
      video.setAttribute('playsinline', '');
    } catch (e) {
      /* no-op */
    }
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(function () {
        /* autoplay bloccato dal browser: nessun errore in console */
      });
    }
  }

  function stopVideo(video) {
    if (!video) return;
    try {
      video.pause();
      video.currentTime = 0;
    } catch (e) {
      /* no-op */
    }
  }

  /* ---------------------------------------------------------------- DESKTOP */
  if (!isCoarse) {
    document.addEventListener(
      'pointerenter',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        var cardMedia = target.closest(CARD_MEDIA);
        if (!cardMedia) return;
        playVideo(getVideo(cardMedia));
      },
      true
    );

    document.addEventListener(
      'pointerleave',
      function (event) {
        var target = event.target;
        if (!target || !target.closest) return;
        var cardMedia = target.closest(CARD_MEDIA);
        if (!cardMedia) return;
        stopVideo(getVideo(cardMedia));
      },
      true
    );

    return;
  }

  /* ----------------------------------------------------------------- MOBILE */
  var activeCard = null;
  var observer = null;

  function deactivate() {
    if (!activeCard) return;
    activeCard.classList.remove(ACTIVE_CLASS);
    stopVideo(getVideo(activeCard));
    if (observer) observer.unobserve(activeCard);
    activeCard = null;
  }

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting && entry.target === activeCard) {
            deactivate();
          }
        });
      },
      { threshold: 0.1 }
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var link = target.closest(CARD_LINK);
      if (!link) {
        deactivate();
        return;
      }

      var cardMedia = link.closest(CARD_MEDIA);
      if (!cardMedia) return;

      /* Nessun video sulla card: comportamento standard, vai al prodotto. */
      if (!getVideo(cardMedia)) return;

      /* Secondo tap sulla stessa card: lascia passare il click. */
      if (cardMedia.classList.contains(ACTIVE_CLASS)) return;

      event.preventDefault();
      event.stopPropagation();

      deactivate();
      activeCard = cardMedia;
      cardMedia.classList.add(ACTIVE_CLASS);
      playVideo(getVideo(cardMedia));
      if (observer) observer.observe(cardMedia);
    },
    true
  );
})();
